import React from "react";
import { any, func } from "prop-types";
import { connect } from "react-redux";
import FormCreatorV2 from "../../common/FormCreatorV2";

import {
  formCreatorConvertToValues,
  useForm,
  getField,
} from "../../common/FormCreator/helpers";
import history from "../../history";
import HorizontalLine from "../../common/HorizontalLine";
import { postABMForms } from "../../redux/actions/abmActions";

const ConsentForm = ({ appData, postABMFormFunc }) => {
  const { firstName = "", lastName = "", nationalInsuranceNo = "" } = appData;

  let initialData = {
    Consent10: `${firstName} ${lastName}`,
    Consent11: nationalInsuranceNo,
    Consent12: `${firstName} ${lastName}`,
  };

  if (appData.abmOnboarding && appData.abmOnboarding.consent) {
    initialData = {
      ...initialData,
      ...appData.abmOnboarding.consent,
    };
  }

  const getVal = getField(initialData);

  const initialState = {
    Consent1: {
      title: "Consent To Release Information",
      type: "heading",
      textDescription: [
        " I give my permission for ABM Aviation UK Limited to approach all referees given on my application form for references. This includes any educational establishments I have attended and any periods of unemployment to be confirmed by the job centre.",
      ],
    },
    Consent2: {
      title: "Consent to Apply For Criminal Record Check",
      type: "heading",
      textDescription: [
        "HRGO Recruitment (acting on behalf of ABM Aviation UK Limited) is proposing to submit an application to Disclosure and Barring Service/Disclosure Scotland for a basic disclosure. A basic disclosure certificate will contain information about any unspent convictions held in your name or confirm that no such unspent convictions exist.",
      ],
    },
    Consent3: {
      title:
        "By signing this statement, you are consenting to all of these statements",
      type: "heading",
      textDescription: [
        "I understand and give my consent to HRGO Recruitment (acting on behalf of ABM Aviation UK Limited):",
        "- Submitting an application to Disclosure and Barring Service/Disclosure Scotland on my behalf for a basic disclosure certificate.",
        "- Receiving and viewing my basic disclosure certificate prior to me seeing it.",
        "- Being advised by email from Disclosure and Barring Service/Disclosure Scotland about whether or not my basic disclosure certificate will contain information about unspent convictions.",
        "- I confirm ABM Aviation UK Limited has confirmed that if Disclosure and Barring Service/Disclosure Scotland indicates that my basic disclosure certificate will contain information, that a recruitment decision about me will not be made until the content of that certificate is considered by ABM Aviation UK Limited.",
      ],
    },
    Consent4: {
      htmlObj: (
        <div>
          <HorizontalLine text={"Privacy Policy - basics check declaration"} />
          <p style={{ color: "#495057", fontSize: "13px" }}>
            I have read the Basic DBS Check Processing Privacy Policy{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.gov.uk/government/publications/dbs-privacy-policies"
            >
              https://www.gov.uk/government/publications/dbs-privacy-policies
            </a>{" "}
            and I understand how DBS will process my personal data.
          </p>
        </div>
      ),
    },
    Consent5: {
      title: "I understand and agree with the above declaration",
      value: getVal("Consent5"),
      type: "radio",
      radioOptions: ["Yes", "No"],
      mandatory: true,
    },
    Consent6: {
      title: "Consent to obtain basic check electronic result",
      type: "heading",
      textDescription: [
        "I consent to the DBS providing an electronic result directly to the responsible organisation that has submitted my application. I understand that an electronic result contains a message that indicates either the certificate does not contain criminal record information or to await certificate which will indicate that my certificate contains criminal record information.",
      ],
    },
    Consent7: {
      title: "I understand and agree with the above declaration",
      value: getVal("Consent7"),
      type: "radio",
      radioOptions: ["Yes", "No"],
      mandatory: true,
    },
    Consent8: {
      title: "Declaration by applicant",
      type: "heading",
      textDescription: [
        "I have provided complete and true information in support of the application and I understand that knowingly making a false statement for this purpose is a criminal offence.",
      ],
    },
    Consent9: {
      title: "I understand and agree with the above declaration",
      value: getVal("Consent9"),
      type: "radio",
      radioOptions: ["Yes", "No"],
      mandatory: true,
    },
    Consent10: {
      title: "Full name",
      value: getVal("Consent10"),
      type: "text",
      mandatory: true,
    },
    Consent11: {
      title: "NI Number",
      value: getVal("Consent11"),
      type: "text",
      mandatory: true,
    },
    Consent12: {
      title: "Signature",
      value: getVal("Consent12"),
      type: "text",
      mandatory: true,
    },
  };

  const [fields, setField] = useForm(initialState);

  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);

    postABMFormFunc("consent", {
      ...fieldValuesPayload,
      name: `${firstName} ${lastName}`,
    });

    history.push("/profile/edit/ABM-onboarding");
  };

  return (
    <FormCreatorV2
      formTitle={"Consent"}
      fields={fields}
      setField={setField}
      handleSubmit={handleSubmit} // handles save to JSON
      handleCancel={() => history.push("/profile/edit/ABM-onboarding")}
      onboardingBranch={"ABM"}
    />
  );
};

ConsentForm.propTypes = {
  appData: any,
  postABMFormFunc: func,
};

const mapDispatchToProps = {
  postABMFormFunc: postABMForms,
};

const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(ConsentForm);
